// eslint-disable-next-line no-shadow
enum SearchSubject {
	INTERNSHIP = "INTERNSHIP_SUBJECT",
	WORK_STUDY = "WORK_STUDY_SUBJECT",
}

export default SearchSubject
